import cn from 'helpers/cn'
import siteConfig from 'config'
import { FC, useRef } from 'react'
import Header from './Header'
import { Outlet, useParams } from 'react-router'
import useAvailableShortsData from 'hooks/testSelect/useAvailableShortsData'
import useTitle from 'hooks/useTitle'
import { Link } from 'react-router-dom'

const ShortsPicker: FC = () => {
  const subject = useParams().subject
  const subjects = useAvailableShortsData()
  const wrapper = useRef<HTMLDivElement>(null)

  const subjectHidden = !!subject

  const nothingShown = subjectHidden

  const title = subject ? `${subjects?.[subject]} - Shorts` : "Shorts"
  const description = subject ? `${subjects?.[subject]} - ${siteConfig.labels.shorts.subjectDescription}` : siteConfig.labels.shorts.pickerDescription

  useTitle(title, description)

  return (
    <>
      <div className="absolute inset-0 z-[10]" style={subject ? {pointerEvents: "auto"} : {pointerEvents: "none"}}>
        <Outlet />
      </div>
      <div ref={wrapper} className={cn("flex transition-all flex-col pt-[calc(93px+1.5rem)] mobile:pt-[calc(10rem)] items-center h-0 overflow-visible animate-fade-in-delay", subjectHidden && "pointer-events-none")}>
        <div className={cn("transition-all", subjectHidden && "opacity-0")}>
          <Header pick={subject && " "} hideDubky={subjectHidden} />
        </div>
        <div
          ref={(e) => {
            if (!e) return
            if (!subjectHidden) {
              e.classList.add("in")
              e.classList.remove("out")
            } else {
              !nothingShown && e.classList.contains("in") && e.classList.remove("in")
              !e.classList.contains("out") && e.classList.add("out")
            }
          }}
          className={cn('flex flex-col gap-4 mt-8 items-center pb-8 animate-subj', subject && 'pointer-events-none')}
        >
          {
            Object.keys(subjects || {} as Record<string, string>).map((s, i) => (
              <Link
                key={s}
                ref={(e) => {
                  if (!e) return
                  e.style.setProperty('--subj-index', `${i}`)
                }}
                className="button-primary px-6 w-max"
                to={`/shorts/${s}`}
              >
                {subjects?.[s]}
              </Link>
            ))}
        </div>
      </div>
    </>
  )
}

export default ShortsPicker
